import { LogManager } from '@src/utility/Logger';
import { makeAutoObservable } from 'mobx';

import type { RootStore } from './RootStore';
import type { Logger } from '@src/utility/Logger';

/**
 * LayoutStore manages the layout-related state of the application.
 */
export class LayoutStore {
  // Core state
  timelineHeight: string = '30%';
  transcriptWidth: string = '380px';
  isDragging: boolean = false;

  // Non-observable properties
  private _rootStore: RootStore;
  private _logger: Logger;
  transcriptMinWidth = 190;
  transcriptMaxWidth = 760;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
    this._logger = LogManager.getLogger('layout-store');

    makeAutoObservable(this, {
      transcriptMinWidth: false,
      transcriptMaxWidth: false,
    });
  }

  setTimelineHeight(newHeight: number) {
    this.timelineHeight = `${newHeight}%`;
  }

  setTranscriptWidth(newWidth: number) {
    this.transcriptWidth = `${newWidth}px`;
  }

  setIsDragging(isDragging: boolean) {
    this.isDragging = isDragging;
  }
}
